/*
 * Module for demonstrating dynamic correspondence forms
*/

rs.module("development/codedemoscorrespondenceform",

    [ ],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl) {

            $.js(jsSelectors.currentForm).on("change", function () {

                $.get(backendUrl, { templateid: $(this).val() }, function (response) {

                    $.js(jsSelectors.formContainer).html(response);

                    var form = $.js(jsSelectors.form);

                    // Reset validation
                    $.validator.resetValidation(form);
                });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
